import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { UserSessionService } from '../../UserSession/user-session.service';
import { ReportsService } from '../../apiclient';

/**
 * @ignore
 */
@Component({
  selector: 'ngx-detalle-informe',
  templateUrl: './detalle-informe.component.html',
  styleUrls: ['./detalle-informe.component.scss']
})
export class DetalleInformeComponent implements OnInit {
  tipoReporte: string;
  iconos = {
    disease :'bug',
    maintenance: 'toolbox',
    sampling:'vial',
    notebook:'clipboard',
  };
  titulo = {
    disease :'Plaga/Enfermedad',
    maintenance: 'Mantenimiento',
    sampling:'Muestreo',
    notebook:'Cuaderno de campo',
  }
  literalTipoInforme = "";
  report: any;

  constructor(private route: ActivatedRoute,private userSessionService: UserSessionService,
    private reportsService: ReportsService,
    private location: Location) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.tipoReporte = params.get('tipo');
      console.log("Init")
      this.cargarInforme(params.get('report'));
    })
  }
  cargarInforme(idreporte: string) {
    console.log(this.reportsService.getCachedEntitiesResult())
    this.report = this.reportsService.getCachedEntitiesResult().find(reporte => reporte.id == idreporte);
    console.log(this.report);
  }



  back(): void{
    this.location.back()
  }
}
